var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-end mt-12"},[_c('div',[_c('div',{staticClass:"font-7 text-decoration-underline"},[_vm._v("Signature et cachet")]),_c('figure',{staticClass:"image is-110x110 has-text-left"},[_c('img',{attrs:{"src":_vm.signature_url,"alt":"","title":"signature"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }